import axios from 'axios';

// Detect if we're in production by checking the current URL
const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
const API_BASE_URL = isProduction 
  ? '' 
  : (process.env.REACT_APP_API_URL || 'http://localhost:5001');

// Direct database queries - no AI processing
export const dashboardService = {
  // Get current period metrics (replaces AI query for topline metrics)
  async getMetrics(accountId, currentStart, currentEnd, adNameFilter = null) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/dashboard/metrics`, {
        accountId,
        currentStart,
        currentEnd,
        adNameFilter
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching metrics:', error);
      throw error;
    }
  },

  // Get previous period metrics for comparison
  async getPreviousMetrics(accountId, previousStart, previousEnd) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/dashboard/previous-metrics`, {
        accountId,
        previousStart,
        previousEnd
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching previous metrics:', error);
      throw error;
    }
  },

  // Get performance trends (replaces AI query for trends chart)
  async getTrends(accountId, currentStart, currentEnd, trendGrouping, trendLimit, adNameFilter = null) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/dashboard/trends`, {
        accountId,
        currentStart,
        currentEnd,
        trendGrouping,
        trendLimit,
        adNameFilter
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching trends:', error);
      throw error;
    }
  },

  // Get top performing content (replaces AI query for top content)
  async getTopContent(accountId, currentStart, currentEnd, adNameFilter = null) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/dashboard/top-content`, {
        accountId,
        currentStart,
        currentEnd,
        adNameFilter
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching top content:', error);
      throw error;
    }
  },

  // Get ad types breakdown (replaces AI query for ad types)
  async getAdTypes(accountId, currentStart, currentEnd, adNameFilter = null) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/dashboard/ad-types`, {
        accountId,
        currentStart,
        currentEnd,
        adNameFilter
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching ad types:', error);
      throw error;
    }
  },

  // Get highest spending features (replaces AI query for features)
  async getFeatures(accountId, currentStart, currentEnd, adNameFilter = null) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/dashboard/features`, {
        accountId,
        currentStart,
        currentEnd,
        adNameFilter
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching features:', error);
      throw error;
    }
  }
};

export default dashboardService;
